import React from "react";
import { PdfHeader } from "../../../../components";

const AgreementReport = React.forwardRef((props, ref) => {
    return (
        <div ref={ref} className="approval-Report">
            <div className="report-container" style={{ minHeight: "297mm", boxSizing: "border-box" }}>
                <PdfHeader pdfName={props?.pdfName || "User Agreement"} customBranding="MLAWYER LEGAL CONSULTATION (P) LTD." />
                <div className="agreement-markdown-content" style={{ padding: "20px 40px", fontSize: "14px", lineHeight: "1.6", color: "#333" }}>
                    <div dangerouslySetInnerHTML={{ __html: props?.htmlContent }} />
                </div>
            </div>
        </div>
    );
});

export default AgreementReport;
